module.exports = __webpack_public_path__ + "img/Auxiliadora-SJDR.3903d858.png";